import {Injectable, Inject} from 'ng-metadata/core';
import {getVid} from '../../appConfig/appConfigForward';

@Injectable()
export class ResourceRecommenderService {
    private view = getVid();
    private restUrl:string;
    private resouceRecTypeCount: Map<string, string> = new Map<string, string>();

    constructor(@Inject('$http') private $http: ng.IHttpService,
                @Inject('restBaseURLs')  restBaseURLs,
                @Inject('$translate')  private $translate: ng.translate.ITranslateService,
    ) {
        this.restUrl = restBaseURLs.resourceRecommenderUrl;

    }

    getRecommendations(query) {
		if (query.endsWith(',AND')){
			query = query.slice(0, -4);
		}
        let dataToBeSent = {
            query: query,
            view: this.view,
            lang: this.$translate.use()
        };

        return this.$http.get(this.restUrl, {
            params:dataToBeSent
        });

    }

    getRecommendationCount(recType){
        if(this.resouceRecTypeCount.has(recType))
            return String(this.resouceRecTypeCount.get(recType));
        return "0";
    }

    setRecommendationCount(recType, recCount){
        this.resouceRecTypeCount.set(recType, recCount);
    }

    resetRecommendetions(){
        this.resouceRecTypeCount.forEach((value: string, key: string) => {
          this.setRecommendationCount(key, "0");
        });
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/resourceRecommender/resourceRecommender.service.ts